/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-16 10:52:49
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-12-24 17:06:56
 * @FilePath: /unifyxp-v2-store-portal/src/components/Modules/Text/index.tsx
 */
/**
 *  ColorPicker Wrapped with title
 *  Author: Luke
 *  CreatedAt: 2021-03-04
 */
import React from 'react';

import { Checkbox, Input } from '@/src/components/Antd';
import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import ColorPicker from 'src/components/ColorPicker/ColorPicker';

// import {
//   //Input,
//   TextArea,
//   //
// } from 'src/components/Antd';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import Editor from 'src/constrains/BraftEditor';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.less';
//import { SeoTag } from '@/src/pages/SalesChannelContentEditor/common';

const Text = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    staticData,
    onStaticChange,
    linkSet,
    disableTagCheckbox,
    disabled,
    //specificError,
  } = props;

  const {
    backgroundColor,
    //textColor, header,
    h1TagEnabled,
    content,
    margin: { top, bottom, left, right },
    //seoTag
  } = staticData;

  const handleOnStaticChange = (data) => {
    if (onStaticChange) {
      onStaticChange(data);
    }
  };

  return (
    <React.Fragment>
      <Section bottomBorder>
        <ItemWrapper
          // title='Background Colour'
          containerClassName={css.colorPickerWidth}>
          <Checkbox
            checked={h1TagEnabled}
            disabled={disableTagCheckbox || disabled}
            onChange={(value) => {
              handleOnStaticChange({ h1TagEnabled: value });
            }}>
            {getI18n('general.setaspageH1tag')}
          </Checkbox>
        </ItemWrapper>
      </Section>
      <Section bottomBorder>
        <ItemWrapper
          title={getI18n('general.backgroundColour')}
          containerClassName={css.colorPickerWidth}>
          <ColorPicker
            onChange={(e) => {
              handleOnStaticChange({ backgroundColor: e });
            }}
            color={backgroundColor}
            multi
            disable={disabled}
          />
        </ItemWrapper>
        {/* <ItemWrapper
          title='Text Colour'
          containerClassName={css.colorPickerWidth}>
          <ColorPicker
            onChange={(e) => {
              handleOnStaticChange({ textColor: e });
            }}
            color={textColor}
            options={['#000000', '#ffffff']}
          />
        </ItemWrapper> */}
      </Section>
      <Section bottomBorder>
        <div className={css.columnLayout}>
          <ItemWrapper title={getI18n('general.topMargin')}>
            <Input
              size='large'
              value={top}
              onChange={(value) => {
                handleOnStaticChange({
                  margin: { top: value, bottom, left, right },
                });
              }}
              suffix='px'
              disabled={disabled}
            />
          </ItemWrapper>
          <ItemWrapper
            title={getI18n('general.bottomMargin')}
            containerClassName={css.marginRight}>
            <Input
              size='large'
              value={bottom}
              onChange={(value) => {
                handleOnStaticChange({
                  margin: { bottom: value, top, left, right },
                });
              }}
              suffix='px'
              disabled={disabled}
            />
          </ItemWrapper>
        </div>
        <div className={css.columnLayout}>
          <ItemWrapper title={getI18n('general.leftMargin')}>
            <Input
              size='large'
              value={left}
              onChange={(value) => {
                handleOnStaticChange({
                  margin: { left: value, top, bottom, right },
                });
              }}
              suffix='px'
              disabled={disabled}
            />
          </ItemWrapper>
          <ItemWrapper
            title={getI18n('general.rightMargin')}
            containerClassName={css.marginRight}>
            <Input
              size='large'
              value={right}
              onChange={(value) => {
                handleOnStaticChange({
                  margin: { right: value, top, bottom, left },
                });
              }}
              suffix='px'
              disabled={disabled}
            />
          </ItemWrapper>
        </div>
      </Section>
      <Section>
        {/* <ItemWrapper title='SEO Tag'>
          <Select
            onChange={(e) => {
              handleOnStaticChange({ seoTag: e });
            }}
            size='large'
            value={seoTag}
            optionsList={SeoTag}
          />
        </ItemWrapper> */}
        {/* <ItemWrapper title='Header'>
          <Input
            size='large'
            value={header}
            maxLength={50}
            onChange={(e) => {
              handleOnStaticChange({ header: e });
            }}
          />
        </ItemWrapper> */}
        <ItemWrapper title={getI18n('general.text')}>
          <Editor
            linkSet={linkSet}
            data={content}
            onChange={({ data }) => {
              handleOnStaticChange({ content: data });
            }}
            disabled={disabled}
          />
          {/* <TextArea
            size='large'
            value={content}
            maxLength={100}
            onChange={(e) => {
              handleOnStaticChange({ content: e });
            }}
          /> */}
        </ItemWrapper>
      </Section>
    </React.Fragment>
  );
};
export default Text;
